import { Types } from "../actions/EquipmentReportActions";

const initialState = {
    equipmentReportList: {},
    plantsList: {},
    equipmentReportloading: false,
    isTaskUpdatedEquipmentReport: false,
};

export const equipmentReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_EQUIPMENT_REPORT_LIST:
            return {
                ...state,
                equipmentReportList: action.payload,
                equipmentReportloading: false,
            };
        case Types.SET_PLANTS:
                return {
                    ...state,
                    plantsList: action.payload ?? state.plantsList,
                };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedEquipmentReport: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedEquipmentReport: false,
            };
        default:
            return state;
    }
};
